import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom"
import API from '../servicios/api';
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from '../elementos/Header'
import {ContenedorBotonesLista, BotonEditar, BotonEliminar} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoEditar} from '../imagenes/editar.svg'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import Boton from '../elementos/Boton'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'

const ListarTipoPublicaciones = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [tipopublicaciones, setAutores] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [idEliminar, setidEliminar] = useState();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, []);

    //Este hook se ejecuta solamente al primer renderizado
    const cargarDatos = () => {
        fetch(API+"?consultarTipoPublicaciones")
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setAutores(datosRespuesta);
        })
        .catch(console.log)
    }

    const handleModal = (id) => {
        setidEliminar(id);
        setEstadoModal(true);
    }

    const borrarRegistro = ()=> {
        setEstadoModal(false);
        setEstadoAlerta(false);
        setAlerta({});
        
        fetch(API+"?borrarTipoPublicacion="+idEliminar)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.success === 1){
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: 'Tipo de Publicación eliminado correctamente.'
                });
                cargarDatos();
            }
            else{
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: 'No es posible eliminar este tipo de publicación.'
                });
            }
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Lista de Tipo de Publicaciones</Titulo>
                        <ContenedorBotones>
                            <Boton to="/crear-tipo-publicacion" primario="true">Agregar Tipo de Publicación</Boton>
                        </ContenedorBotones>
                    </ContenedorHeader>
                </Header>

                {tipopublicaciones.success === 0 ?
                <p className='ms-3'>No hay información para mostrar.</p>
                :
                <div className="contenedor-tabla">
                    <div className="card card-tamano">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nombre de Tipo de Publicación</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        tipopublicaciones.map(
                                            (tipopublicacion)=>(
                                                <tr key={tipopublicacion.TPub_ID}>
                                                    <td>{tipopublicacion.TPub_Nombre}</td>
                                                    <td>
                                                        <ContenedorBotonesLista>
                                                            <BotonEditar title="Actualizar Tipo de Publicación" as={Link} to={"/editar-tipo-publicacion/"+tipopublicacion.TPub_ID}>
                                                                <IconoEditar />
                                                            </BotonEditar>
                                                            
                                                            <BotonEliminar title="Eliminar Tipo de Publicación" onClick={() => handleModal(tipopublicacion.TPub_ID)}>
                                                                <IconoBorrar />
                                                            </BotonEliminar>
                                                        </ContenedorBotonesLista>
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                }
                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader="Eliminar Tipo de Publicación"
                        mensajeBody="¿Está seguro de eliminar el tipo de publicación?"
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={borrarRegistro}
                />
            </>
        );
    }
}
 
export default ListarTipoPublicaciones;